export default __webpack_public_path__ + "static/115-3cc30d8391d9091e3f5563a0a67719cd.gif";